// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-controlled-treeview {
    height: 400px;
    overflow: auto;
}
.box-loading {
    text-align: center;
    margin-top: 45%;
}
.not-found {
    color: gray;
    margin: 0;
    padding: 1rem;
    font-size: var(--caption);
}`, "",{"version":3,"sources":["webpack://./src/components/components/Treeview/ControlledTreeview.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,yBAAyB;AAC7B","sourcesContent":[".box-controlled-treeview {\n    height: 400px;\n    overflow: auto;\n}\n.box-loading {\n    text-align: center;\n    margin-top: 45%;\n}\n.not-found {\n    color: gray;\n    margin: 0;\n    padding: 1rem;\n    font-size: var(--caption);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
